import(/* webpackMode: "eager", webpackExports: ["TermlyPolicy","TermsAndConditionsPolicyDataId"] */ "/codebuild/output/src1495867874/src/apps/wrap.gifts/src/services/Termly/TermlyPolicy.tsx");
